import React from "react";
import { IconFolder } from "@tabler/icons-react";
import MButtonCard from "@/components/ui/atoms/MButtonCard";

const MButtonCardTest: React.FC = () => {
  return (
    <div className="p-8 space-y-8 bg-[#F6F6F6] min-h-screen">
      <h1 className="text-xl font-semibold">MButtonCard Variants</h1>

      <section className="space-y-4">
        <h2 className="text-lg font-semibold">Type: count, Size: default</h2>
        <div className="flex flex-row gap-4">
          <MButtonCard
            type="count"
            size="default"
            title="All documents"
            count={102}
            icon={<IconFolder />}
          />
        </div>
      </section>

      <section className="space-y-4">
        <h2 className="text-lg font-semibold">Type: plain, Size: sm</h2>
        <div className="flex flex-row gap-4">
          <MButtonCard
            type="plain"
            size="sm"
            title="All documents"
            icon={<IconFolder />}
          />
          <MButtonCard
            type="plain"
            size="sm"
            title="All documents"
            icon={<IconFolder />}
          />
        </div>
      </section>
    </div>
  );
};

export default MButtonCardTest;
